export function cleanTokenName(name: string): string {
	return name.replace(/\.\[default\]/g, '');
}
